import { c as _c } from "react/compiler-runtime";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import { FormEvent, ReactElement, ReactNode, useState } from 'react';
export interface PasswordFormValue {
  email: string;
  password: string;
}
interface PasswordFormProps {
  children?: ReactNode;
  loading: boolean;
  onSubmit: (value: PasswordFormValue) => void;
  disabled?: boolean;
  error?: Error;
}
export function PasswordForm(t0) {
  const $ = _c(29);
  const {
    children,
    loading,
    disabled,
    error,
    onSubmit
  } = t0;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  let t1;
  if ($[0] !== email || $[1] !== onSubmit || $[2] !== password) {
    t1 = function handleSubmit(event) {
      event.preventDefault();
      event.stopPropagation();
      onSubmit({
        email,
        password
      });
    };
    $[0] = email;
    $[1] = onSubmit;
    $[2] = password;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleSubmit = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      gap: 2
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FormLabel htmlFor="email">Email</FormLabel>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = e => setEmail(e.target.value);
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      ariaLabel: "email"
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== disabled || $[9] !== email) {
    t6 = <FormControl>{t3}<TextField required={true} value={email} onChange={t4} name="email" type="email" placeholder="your@email.com" disabled={disabled} id="email" autoComplete="email" autoFocus={true} fullWidth={true} variant="outlined" color="primary" sx={t5} /></FormControl>;
    $[8] = disabled;
    $[9] = email;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FormLabel htmlFor="password">Password</FormLabel>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = e_0 => setPassword(e_0.target.value);
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== password) {
    t9 = <FormControl>{t7}<TextField name="password" placeholder={"\u2022\u2022\u2022\u2022\u2022\u2022"} type="password" id="password" autoComplete="current-password" autoFocus={true} required={true} fullWidth={true} variant="outlined" color="primary" value={password} onChange={t8} /></FormControl>;
    $[13] = password;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== error) {
    t10 = error != null && <span>{error.message}</span>;
    $[15] = error;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const t11 = loading || disabled;
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <CircularProgress size={16} />;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== loading || $[19] !== t11) {
    t13 = <Button loading={loading} disabled={t11} variant="contained" type="submit" fullWidth={true} loadingIndicator={t12}>Sign in</Button>;
    $[18] = loading;
    $[19] = t11;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Divider>or</Divider>;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== children || $[23] !== handleSubmit || $[24] !== t10 || $[25] !== t13 || $[26] !== t6 || $[27] !== t9) {
    t15 = <Box component="form" onSubmit={handleSubmit} sx={t2}>{t6}{t9}{t10}{t13}{t14}{children}</Box>;
    $[22] = children;
    $[23] = handleSubmit;
    $[24] = t10;
    $[25] = t13;
    $[26] = t6;
    $[27] = t9;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  return t15;
}